import { render, staticRenderFns } from "./customer_service.vue?vue&type=template&id=1c89952c&scoped=true&"
import script from "./customer_service.vue?vue&type=script&lang=js&"
export * from "./customer_service.vue?vue&type=script&lang=js&"
import style0 from "./customer_service.vue?vue&type=style&index=0&id=1c89952c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89952c",
  null
  
)

component.options.__file = "customer_service.vue"
export default component.exports